/* eslint-disable no-restricted-imports */
import React, { useEffect, useState, useCallback } from "react";
import {
  InputLabel,
  Button,
  RadioGroup,
  Radio,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Toast, Col, Row } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { v4 as uuidv4 } from "uuid";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { OrgList } from "./OrgList";
import { AccountEdit } from "./AccountEdit";
import {
  getUserListData,
  getAllQuotaUsage
} from "../modules/Auth/_redux/adminCrud";

export function SelectUser(data) {
  const useStyles = makeStyles(theme => ({
    treeContainerStyle: {
      display: "inline-block",
      width: "250px",
      height: "500px",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px",
      marginRight: "12px",
      verticalAlign: "top"
    },
    listContainerStyle: {
      display: "inline-block",
      width: "316px",
      height: "500px",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px",
      overflowY: "scroll"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "2px 2px 2px 2px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      // border: "1px solid lightgray",
      padding: "0 24px 0 24px",
      marginBottom: "8px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleInnerStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      margin: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      fontWeight: "bold",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "auto",
      textOverflow: "ellipsis"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      //   paddingTop: "6px",
      //   "&:hover": {
      //     color: "#123456",
      //     backgroundColor: "#eae4f5 !important"
      //   },
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const [memberListOrg, setMemberListOrg] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [userList, setUserList] = useState([]);

  const Styles = useStyles();
  const [refresh, setRefresh] = React.useState(false);
  const [showAsk, setShowAsk] = React.useState(false);
  const [showAskMove, setShowAskMove] = React.useState(false);
  const [showNew, setShowNew] = React.useState(false);
  const [showToast, setShowToast] = React.useState(false);
  const [editTitle, setEditTitle] = React.useState("");
  const [editIP, setEditIP] = React.useState("");
  const [editDesc, setEditDesc] = React.useState("");
  const [deptName, setDeptName] = React.useState(" ");
  const [deptUserCount, setDeptUserCount] = React.useState("(0명)");
  const [showAccount, setShowAccount] = React.useState(false);
  const [allChecked, setAllChecked] = React.useState(false);
  const [editMode, setEditMode] = React.useState("NEW");
  const [editUserData, setEditUserData] = React.useState();
  const [selectedDept, setSelectedDept] = React.useState();

  const [showOrgList, setShowOrgList] = React.useState(false);
  const [tempDeptName, setTempDeptName] = React.useState("");
  // const [deptName, setDeptName] = React.useState("");

  const formatBytes = (bytes = 0, fixed) => {
    const marker = 1024; // Change to 1000 if required
    const decimal = fixed != null ? fixed : 2; // Change as required
    const kiloBytes = marker; // One Kilobyte is 1024 bytes
    const megaBytes = marker * marker; // One MB is 1024 KB
    const gigaBytes = marker * marker * marker; // One GB is 1024 MB
    // const teraBytes = marker * marker * marker * marker; // One TB is 1024 GB

    // return bytes if less than a KB
    if (bytes == null || bytes < kiloBytes) {
      return `${bytes}B`;
      // return KB if less than a MB
    }
    if (bytes < megaBytes) {
      return `${(bytes / kiloBytes).toFixed(decimal)}KB`;
      // return MB if less than a GB
    }
    if (bytes < gigaBytes) {
      return `${(bytes / megaBytes).toFixed(decimal)}MB`;
      // return GB if less than a TB
    }

    return `${(bytes / gigaBytes).toFixed(decimal)}GB`;
  };

  const checkIpAddress = () => {
    return true;
  };

  const handlePressDelete = () => {
    console.log(
      "DELETE",
      userList.filter(user => user.checked)
    );

    setShowAsk(true);
  };

  const handleOrgOnInit = dept => {
    console.log("handleOrgOnInit", dept);

    setDeptName(dept.deptName);
    setRefresh(!refresh);
  };

  const handleGroupUnenrolled = () => {
    const anonymous = [];
    getAllQuotaUsage().then(result => {
      console.log("Zimbra Accounts", result.data.quotaUsage);

      getUserListData(null).then(result1 => {
        console.log("USERS", result1.data.users);
        if (result1.data.users != null) {
          for (var aa = 0; aa < result.data.quotaUsage.length; aa += 1) {
            let found = false;
            for (var ii = 0; ii < result1.data.users.length; ii += 1) {
              if (
                result1.data.users[ii].email === result.data.quotaUsage[aa].name
              ) {
                found = true;
                break;
              }
            }

            if (!found)
              anonymous.push({
                email: result.data.quotaUsage[aa].name,
                userId: result.data.quotaUsage[aa].name,
                name: result.data.quotaUsage[aa].name.split("@")[0],
                status: "활성",
                teamName: "미분류",
                checked: false,
                mailQuota: `${formatBytes(result.data.quotaUsage[aa].used)} / ${
                  result.data.quotaUsage[aa].limit > 0
                    ? formatBytes(result.data.quotaUsage[aa].limit)
                    : "무제한"
                }`
              });
          }

          console.log("ANONYMOUS", anonymous);
          setUserList(anonymous);
          setDeptName("미분류");
          setDeptUserCount("(" + anonymous.length + "명)");
          setRefresh(!refresh);
        }
      })
      .catch(error => {
        console.log(error)
      })
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handleOrgDeptSelected = dept => {
    console.log("handleOrgDeptSelected", dept);
    if (dept?.subList != null && dept?.subList.length > 0) return;

    if (dept?.deptCode === 77777) {
      handleGroupUnenrolled();
      return;
    }

    setSelectedDept(dept);

    getUserListData(dept?.deptCode).then(result => {
      console.log("USERS", result);
      if (result.data.users != null) {
        result.data.users.map(user => {
          user.status = "활성";
          user.level = "사용자";
          user.checked = false;
          user.isAnonymous = false;
          user.mailQuota = `${formatBytes(user.used)} / ${
            user.limit > 0 ? formatBytes(user.limit) : "무제한"
          }`;
          user.date = user.createDt.split("T")[0];
        });

        if (dept == null && data.mode === "MODIFY") {
          result.data.users.map(user => {
            memberList.forEach(member => {
              console.log("-->", user.name, user.email);

              if (member._content === user.email) member.name = user.name;
            });
          });
        }

        setUserList(result.data.users);
        if (dept != null) setDeptName(dept.deptName);
        setDeptUserCount(`(${result.data.users.length}명)`);
        setRefresh(!refresh);
      }
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handlePressAddMember = () => {
    const selected = userList.filter(user => user.checked === true);
    if (selected == null || selected.length === 0) return;

    selected.forEach(sel => {
      const index = memberList.findIndex(el => el._content === sel.email);

      console.log("--> ", index, sel.email);
      if (index === -1) {
        console.log("--> XXXX");
        memberList.push({
          _content: sel.email,
          name: sel.name,
          isAnonymous: sel.isAnonymous
        });
      }
    });

    setMemberList(memberList);

    userList.map(user => (user.checked = false));
    setAllChecked(false);

    setRefresh(!refresh);
  };

  useEffect(() => {}, [refresh, memberList]);

  useEffect(() => {
    if (data.mode === "MODIFY") {
      setMemberList(Object.assign(data.userData) || []);
      // setMemberListOrg(Object.assign(data.userData) || []);

      data.userData.forEach(data => {
        memberListOrg.push(Object.assign(data));
      })
      setMemberListOrg(memberListOrg);

    } else {
      setMemberList([]);
      setMemberListOrg([]);
    }

    handleOrgDeptSelected(null);
  }, []);

  return (
    <>
      <div
        style={{
          marginTop: "12px",
          marginLeft: "-12px",
          height: "100%",
          width: "800px"
        }}
      >
        {/* -------------------- */}

        <div className={Styles.boxContainer}>
          <div className={Styles.boxStyle}>
            <div className={Styles.subTitleInnerStyle}>그룹 멤버 추가</div>
            <div className={Styles.treeContainerStyle}>
              <OrgList
                onClick={handleOrgDeptSelected}
                onInit={handleOrgOnInit}
                useAnonymous
              />
            </div>

            <div className={Styles.listContainerStyle}>
              <div className={Styles.subTitleInnerStyle}>
                {deptName} {deptUserCount}
                <div
                  style={{
                    display: "inline-flex",
                    float: "right",
                    marginRight: "32px",
                    marginTop: "-4px"
                  }}
                >
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => handlePressAddMember()}
                  >
                    추가
                  </Button>
                </div>
              </div>
              <div className={Styles.headerRowStyle}>
                <div className={Styles.headerCheckboxStyle}>
                  <FormControlLabel
                    style={{ marginLeft: "unset" }}
                    control={
                      <Checkbox
                        checked={allChecked}
                        onChange={e => {
                          console.log("XXX", e);
                          setAllChecked(!allChecked);
                          userList.map(user => (user.checked = !allChecked));
                          setRefresh(!refresh);
                        }}
                        value="true"
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                    }
                  />
                </div>
                <div className={Styles.headerColStyle}>아이디</div>
                <div className={Styles.headerColStyle}>이름</div>
                <div className={Styles.headerColStyle}>상태</div>
                {/* <div className={Styles.headerColStyle}>권한</div> */}
              </div>

              <div
                style={{
                  height: "calc(640px - 44px)",
                  overflowY: "scroll"
                }}
              >
                {userList.map(user => (
                  <div className={Styles.dataRowStyle} key={uuidv4()}>
                    <div className={Styles.dataCheckboxStyle}>
                      <FormControlLabel
                        style={{ marginLeft: "unset" }}
                        control={
                          <Checkbox
                            checked={user.checked}
                            onChange={e => {
                              user.checked = !user.checked;
                              console.log("XXX", user.checked);
                              setRefresh(!refresh);
                            }}
                            value="true"
                            inputProps={{
                              "aria-label": "primary checkbox"
                            }}
                          />
                        }
                      />
                    </div>
                    <div className={Styles.dataColStyle}>{user.userId}</div>
                    <div className={Styles.dataColStyle}>{user.name}</div>
                    <div className={Styles.dataColStyle}>{user.status}</div>
                    {/* <div className={Styles.dataColStyle}>{user.level}</div> */}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div
            className={Styles.subTitleInnerStyle}
            style={{ margin: "0 0 8px 36px" }}
          >
            선택된 멤버
          </div>
          <div
            style={{
              height: "150px",
              width: "578px",
              marginLeft: "24px",
              marginRight: "24px",
              paddingBottom: "8px",
              border: "1px solid #c8cace",
              borderRadius: "4px 4px 4px 4px",
              overflowY: "scroll"
            }}
          >
            {memberList.map(member => (
              <div
                style={{
                  display: "inline-flex",
                  height: "21px",
                  // width: "",
                  fontSize: "1rem",
                  marginTop: "4px",
                  marginLeft: "4px",
                  marginRight: "4px",
                  color: "#123456",
                  border: "1px solid #123456",
                  borderRadius: "24px",
                  paddingLeft: "8px",
                  paddingRight: "8px"
                }}
                key={uuidv4()}
              >
                {member.name === undefined
                  ? member._content
                  : member.name + " <" + member._content + ">"}{" "}
                &nbsp;&nbsp;
                <span
                  onClick={() => {
                    for (var ii = 0; ii < memberList.length; ii++) {
                      if (memberList[ii]._content === member._content) {
                        memberList.splice(ii, 1);
                        break;
                      }
                    }
                    setMemberList(memberList);
                    setRefresh(!refresh);

                  }}
                >
                  x
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <DialogActions>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            paddingBottom: "8px"
          }}
        >
          <Button
            className={Styles.buttonSmallStyle}
            onClick={() => {
              setShowOrgList(false);
              if (data.onCancel != undefined) data.onCancel();
            }}
          >
            취소
          </Button>
          <Button
            style={{ marginLeft: "24px" }}
            className={[Styles.buttonSmallStyle]}
            autoFocus
            onClick={() => {
              if (data.onApply != undefined) {
                const deletedList = [];


                
                console.log('FFFFFFF ', memberListOrg);

                for (let aa = 0; aa < memberListOrg.length; aa += 1) {
                  let found1 = false;
                  console.log(' ===> ', memberListOrg[aa]._content);

                  for (let bb = 0; bb < memberList.length; bb += 1) {
                    console.log(memberList[bb]._content);
                    if (memberListOrg[aa]._content === memberList[bb]._content) {
                      found1 = true;
                      break;
                    }
                  }

                  console.log(' FOUND ', memberListOrg[aa], found1, typeof found1, !found1);
                  if(!found1) {
                    console.log(' XXXXXXXX ', memberListOrg[aa]);
                    deletedList.push(memberListOrg[aa]);
                  }
                }

                console.log(' XXXXX ', memberListOrg, deletedList);

                data.onApply(memberList, deletedList);
              }
            }}
          >
            저장
          </Button>
        </div>
      </DialogActions>
    </>
  );
}
